export const APP_VERSION = process.env.REACT_APP_VERSION;
